module.exports = __webpack_public_path__ + "img/sms-logo-white.189f4a59.svg";